import { defineMessages } from '@/i18n'

/** Подписи карточек типов блоков (меню добавления экрана). */
export const messages = defineMessages({
  ru: {
    imageLabel: 'Изображение',
    imageDescription: 'Картинка на весь экран',
    videoLabel: 'Видео',
    videoDescription: 'Видео 9:16 или 16:9',
    articleLabel: 'Инструкция',
    articleDescription: 'Статья из библиотеки',
    designLabel: 'Составной блок',
    designDescription: 'Текст, таблицы, картинки, бейджи',
    quizSingleLabel: 'Один ответ',
    quizSingleDescription: 'Выбор одного ответа',
    quizMultiLabel: 'Несколько ответов',
    quizMultiDescription: 'Выбор нескольких ответов',
    yesNoLabel: 'Да / Нет',
    yesNoDescription: 'Вопрос Да или Нет',
    fillBlankLabel: 'Заполни пропуск',
    fillBlankDescription: 'Заполнить пропущенное слово',
    matchLabel: 'Соответствие',
    matchDescription: 'Соединить пары',
    headingLabel: 'Заголовок',
    headingDescription: 'Крупный заголовок секции',
    textLabel: 'Текст',
    textDescription: 'Текстовый блок',
    audioLabel: 'Аудио',
    audioDescription: 'Аудио плеер',
    sliderLabel: 'Ползунок',
    sliderDescription: 'Выбрать значение на шкале',
    orderingLabel: 'Порядок',
    orderingDescription: 'Расположить в порядке',
  },
  en: {
    imageLabel: 'Image',
    imageDescription: 'Full-screen image',
    videoLabel: 'Video',
    videoDescription: '9:16 or 16:9 video',
    articleLabel: 'Article',
    articleDescription: 'Article from the library',
    designLabel: 'Composite block',
    designDescription: 'Text, tables, images, badges',
    quizSingleLabel: 'Single choice',
    quizSingleDescription: 'Pick one answer',
    quizMultiLabel: 'Multiple choice',
    quizMultiDescription: 'Pick several answers',
    yesNoLabel: 'Yes / No',
    yesNoDescription: 'Yes-or-no question',
    fillBlankLabel: 'Fill in the blank',
    fillBlankDescription: 'Fill in the missing word',
    matchLabel: 'Matching',
    matchDescription: 'Connect the pairs',
    headingLabel: 'Heading',
    headingDescription: 'Large section heading',
    textLabel: 'Text',
    textDescription: 'Text block',
    audioLabel: 'Audio',
    audioDescription: 'Audio player',
    sliderLabel: 'Slider',
    sliderDescription: 'Pick a value on a scale',
    orderingLabel: 'Ordering',
    orderingDescription: 'Put items in order',
  },
})
